import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import pubSolutionsImage from "../../assets/pub-solutions-image.svg";

const SOLUTION_CARDS = [
    {
        label: "Green Building",
        desc: "Verified on-site records that turn certifications into tamper-evident proof for certifiers, lenders, and ESG capital.",
        path: "/solutions/green-building",
        tag: "NEW",
        color: "#22c55e",
    },
    {
        label: "Banks & Lenders",
        desc: "Evidence-based disbursement decisions with verified milestone data in place of self-reported progress.",
        path: "/solutions/banks",
        tag: null,
        color: "var(--color-primary)",
    },
    {
        label: "NGOs & Aid",
        desc: "Donor funding accountability with tamper-evident proof of field progress across every funding chain.",
        path: "/solutions/ngos",
        tag: null,
        color: "var(--color-primary)",
    },
    {
        label: "Diaspora Investors",
        desc: "A verified record of your build you can check from anywhere, without needing to travel.",
        path: "/solutions/diaspora",
        tag: null,
        color: "var(--color-primary)",
    },
    {
        label: "Contractors",
        desc: "Build a verifiable track record that grows with every project you complete.",
        path: "/solutions/contractors",
        tag: null,
        color: "var(--color-primary)",
    },
    {
        label: "Borderless Portfolio",
        desc: "A globally recognized verified profile for architects and engineers crossing borders.",
        path: "/solutions/borderless",
        tag: null,
        color: "var(--color-primary)",
    },
];

const PubSolutions = () => {
    const navigate = useNavigate();

    return (
        <section className="pub-solutions">
            <h2 className="h1-48-600">One record, <span>built for every party</span> involved</h2>
            <p className="pub-solutions-sub">The same verified record answers a different question depending on who's relying on it.</p>

            <div className="pub-solutions-cards">
                {SOLUTION_CARDS.map((sol) => (
                    <div
                        key={sol.label}
                        className="pub-sol-card"
                        onClick={() => navigate(sol.path)}
                        style={{ "--sol-accent": sol.color }}
                    >
                        {sol.tag && <span className="pub-sol-tag">{sol.tag}</span>}
                        <h3 className="pub-sol-card-title">{sol.label}</h3>
                        <p className="pub-sol-card-desc">{sol.desc}</p>
                        <span className="pub-sol-card-link">
                            Learn more <FaArrowRight style={{ marginLeft: 6, fontSize: "1.1rem" }} />
                        </span>
                    </div>
                ))}
            </div>

            {/* <div className="pub-solutions-img-wrap">
                <img src={pubSolutionsImage} alt="Solutions that power the entire project lifecycle" className="pub-solutions-img" />
            </div> */}

            {/* <div className="pub-solutions-cta">
                <button
                    className="pub-solutions-btn"
                    onClick={() => window.open("https://web.conra.net", "_blank")}
                >
                    View All Solutions <FaArrowRight style={{ marginLeft: 8 }} />
                </button>
            </div> */}
        </section>
    );
};

export default PubSolutions;
